import {
  FieldWrapper,
  Input,
  Label,
  LoadingIndicator,
  SingleCombobox,
} from '@commenda/kakashi';
import { useMemo } from 'react';
import { useWorkflow } from '../../context/WorkflowContext';
import { useWorkflowTaskTemplate } from '../../context/WorkflowTaskTemplateContext';
import { TSelectedEntity } from '../../types/node';

export const LegacyServiceRequestProperty = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow, setWorkflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  );

  const { taskGroups: legacyServiceTaskGroups, isLoading } =
    useWorkflowTaskTemplate();

  const selectedGroup = workflow?.stepGroups?.find((group) =>
    group.stepIds?.includes(selectedStep?.id)
  );

  const legacyServiceTaskGroupSelected = legacyServiceTaskGroups.find(
    (taskGroup) =>
      taskGroup.taskGroupId === selectedGroup?.legacyServiceRequestTaskGroupKey
  );

  const legacyServiceTasksOptions = useMemo(() => {
    if (
      !legacyServiceTaskGroupSelected ||
      !legacyServiceTaskGroupSelected?.tasks?.length
    )
      return [];
    return legacyServiceTaskGroupSelected?.tasks?.map((task) => ({
      label: task.taskId,
      value: task.taskId,
    }));
  }, [legacyServiceTaskGroupSelected]);

  const updateLegacyServiceRequest = (legacyServiceRequestTaskKey: string) => {
    setWorkflow({
      ...workflow,
      steps: workflow?.steps.map((step) =>
        step.id === selectedEntity.id
          ? {
              ...step,
              legacyServiceRequestTaskKey,
            }
          : step
      ),
    });
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="flex flex-col gap-4">
      <FieldWrapper>
        <Label>Legacy Service Request Task Group</Label>
        <Input
          value={selectedGroup?.legacyServiceRequestTaskGroupKey}
          disabled
        />
      </FieldWrapper>
      <FieldWrapper>
        <Label>Legacy Service Request Task</Label>
        <SingleCombobox
          options={legacyServiceTasksOptions}
          value={selectedStep?.legacyServiceRequestTaskKey}
          setValue={(value) => updateLegacyServiceRequest(value)}
        />
      </FieldWrapper>
    </div>
  );
};
